import i18n from '@/providers/i18n'

//STORES
export const stores = {
  image: {
    label: null,
    type: 'image',
    required: false,
    size: 2,
  },
  title: 'loyaltyvenue:stores.fields.title',
  store_identifier_url: {
    trans: 'loyaltyvenue:stores.fields.store_identifier_url',
    pattern: /^[a-z0-9][a-z0-9\-]{1,18}[a-z0-9]$/,
  },
  apptokens_apps_id: {
    trans: 'loyaltyvenue:stores.fields.lvstore_apptokens_apps_id',
    disabled: true,
  },
  description: {
    trans: 'loyaltyvenue:stores.fields.description',
    type: 'html',
    required: false,
  },
  lvstore_enabled: {
    trans: 'loyaltyvenue:stores.fields.lvstore_enabled',
    function: (store, el) =>
      el(
        'span', {
          class: (store.lvstore_enabled ? 'enabled' : 'disabled'),
        }, [
          i18n.i18next.t(
            'loyaltyvenue:stores.lvstore.' + (store.lvstore_enabled ? 'enabled_tag' : 'disabled')
          )
        ],
      )
  },
  email: {
    trans: 'loyaltyvenue:stores.fields.email',
    type: 'email',
  },
  phone: {
    trans: 'loyaltyvenue:stores.fields.phone',
    type: 'tel',
    required: false,
  },
  address: {
    trans: 'loyaltyvenue:stores.fields.address',
    required: false,
  },
  meta_keywords: {
    trans: 'loyaltyvenue:stores.fields.meta_keywords',
    required: false,
  },
  meta_description: {
    trans: 'loyaltyvenue:stores.fields.meta_description',
    type: 'textarea',
    required: false,
  },
  google_analytics: {
    trans: 'loyaltyvenue:stores.fields.google_analytics',
    //type: 'text',
    max: 20,
    required: false,
  },
  content_tos: {
    trans: 'loyaltyvenue:stores.fields.content_tos',
    type: 'html',
    required: false,
  },
  social_facebook_url: {
    trans: 'loyaltyvenue:stores.fields.social_facebook_url',
    type: 'url',
    required: false,
  },
  social_twitter_url: {
    trans: 'loyaltyvenue:stores.fields.social_twitter_url',
    type: 'url',
    required: false,
  },
  social_instagram_url: {
    trans: 'loyaltyvenue:stores.fields.social_instagram_url',
    type: 'url',
    required: false,
  },
  social_youtube_url: {
    trans: 'loyaltyvenue:stores.fields.social_youtube_url',
    type: 'url',
    required: false,
  },
  template_colorcode_1: {
    trans: 'loyaltyvenue:stores.fields.template_colorcode_1',
    type: 'color',
    required: false,
  },
  template_colorcode_2: {
    trans: 'loyaltyvenue:stores.fields.template_colorcode_2',
    type: 'color',
    required: false,
  },
};

//REPORTS
export const reports = {
  id: 'loyaltyvenue:reports.fields.id',
  created_at: {
    trans: 'loyaltyvenue:reports.fields.created_at',
    type: 'date',
  },
  reports_types_id: {
    trans: 'loyaltyvenue:reports.fields.reports_types_id',
    type: 'resource',
    resource: 'reports_types',
    getValues: r => r
      .filter(d => {
        var name = d.unique_task_name;
        return 0
          || name.substring(0, 7) === 'orders_'
          || name.substring(0, 12) === 'uniquecodes_'
          || name.substring(0, 10) === 'customers_'
        ;
      })
      .map(r => ({
        id: r.id,
        name: r.name,
      })),
  },
  extension: {
    trans: 'loyaltyvenue:reports.fields.extension',
    type: 'select',
    values: {
      xlsx: 'xlsx',
      csv: 'csv',
    },
  },
  name: {
    trans: 'loyaltyvenue:reports.fields.name',
  },
  description: {
    trans: 'loyaltyvenue:reports.fields.description',
    type: 'textarea',
  },
  content: {
    trans: 'loyaltyvenue:reports.fields.content',
    type: 'html',
  },
  month: {
    trans: 'loyaltyvenue:reports.fields.month',
    type: 'month',
  },
};

export const uniquecodes_intervals = {
  start_at: {
    trans: 'loyaltyvenue:points.intervals.fields.start_at',
    type: 'datetime',
  },
  end_at: {
    trans: 'loyaltyvenue:points.intervals.fields.end_at',
    type: 'datetime',
    after: 'start_at',
  },
  description: {
    trans: 'loyaltyvenue:points.intervals.fields.description',
    type: 'textarea',
    required: false,
    min: 6,
  },
  title: {
    trans: 'loyaltyvenue:points.intervals.fields.title',
    min: 3,
  },
}

export const referrals = {
  id: 'loyaltyvenue:stores.referral.fields.id',
  content: 'loyaltyvenue:stores.referral.fields.content',
  created_at: {
    trans: 'loyaltyvenue:stores.referral.fields.created_at',
    type: 'datetime',
  },
  active: {
    trans: 'loyaltyvenue:stores.referral.fields.active',
    format: 'visible',
  },
}


// WEBPACK FOOTER //
// ./src/apps/loyaltyvenue/fields.js